/**
 * Centralised image asset URLs (CDN-hosted by Emergent).
 * Use these everywhere — no inline raw URLs in components.
 */

export const ASSETS = {
  portrait:
    'https://customer-assets.emergentagent.com/job_trust-dealflow/artifacts/fo5hmhi0_image.png',
  heroBlob:
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/0ae117d51e008ba544ea0a9954f04a055aa784bab8789d3abcd3688e2f855f52.png',
  editorial: [
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/f1b3e8f9e916476fd12a43e7d6740d6bba4a6b53186f6cc983f75d696b7109aa.png',
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/619bd1cc49f39f756f7e65a64487f7e6dcb726a52b78bd286a55d8ab896dae96.png',
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/1318624757593510359ee11f7dff278fadb4d8c28695f99b51c96f1756d63d77.png',
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/78a7faa329f4b52d6d47e656abc748ceec0ec02caa52ee9c94acb8ec8ea23746.png',
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/28c1716d37919539a7415e26d8b57e15657eed05f97bbd92353dbe72b5eca47a.png',
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/92a48ba4179fa5ba7daa916642c1bdd0dfa97ed9a4e2d43df445a0ee8a5e33f0.png',
    'https://static.prod-images.emergentagent.com/jobs/e64313a9-f801-43e7-b9b9-abd5991bc875/images/cd4741a957b749902426827327dd25d2059226cdc2652b5cb3683629546938d6.png',
  ],
};

export default ASSETS;
